import { Tooltip } from "react-bootstrap";

export const tooltip = <Tooltip id="tooltip-example">Download</Tooltip>;
